import { useCallback, useMemo } from "react";
import { Particulars as ParticularsGrid } from "@idwal/idwal-react-components";
import { formatNumber } from "../../utils/numberHelpers";
import { ScreeningItem } from "../../types/Screening";
import { formatDecimalAge } from "../../utils/dates";
import dayjs from "dayjs";

type Props = {
    data: ScreeningItem;
};

export const ScreeningParticulars = (props: Props) => {
    const { data } = props;

    const formatDate = useCallback(
        (date: string) => dayjs(date).format("DD/MM/YYYY"),
        [data]
    );

    const formatYesNo = useCallback(
        (yesNo: string) => {
            if (yesNo === "Y") {
                return "Yes";
            }

            if (yesNo === "N") {
                return "No";
            }

            return yesNo;
        },
        [data]
    );

    const particulars = useMemo(() => {
        const particularsData: Record<string, string> = {
            shipName: data.vessel_name,
            iMONumber: `${data.vessel_imo}`,
            exName: data.ex_name,
            portOfRegistry: data.port_of_registry,
            shipType: data.vessel_type,
            flag: `${data.flag_state}${
                data.flag_code ? ` (${data.flag_code})` : ""
            }`,
            classificationSociety: `${data.class_society}${
                data.class_code ? ` (${data.class_code})` : ""
            }`,
            registeredOwner: data.registered_owner,
            technicalManager: data.technical_manager,
            shipbuilder: data.builder,
            dateDelivered: formatDate(data.age_date),
            shipAge: formatDecimalAge(data.age_of_vessel),
            countryOfBuild: `${data.build_country}${
                data.build_country_code ? ` (${data.build_country_code})` : ""
            }`,
            keelLaid: formatDate(data.keel_laid_date),
            operator: data.operator,
            "p&IClub": data.pandi_club,
            callsign: data.call_sign,
            gearless: formatYesNo(data.gearless),
            deadweight: `${formatNumber(data.dwt)} MT`,
            grossTonnage: `${formatNumber(data.gross_tonnage)} MT`,
            netTonnage: `${formatNumber(data.net_tonnage)} MT`,
            length: `${formatNumber(data.length)} m`,
            breadth: `${formatNumber(data.breadth)} m`,
            depth: `${formatNumber(data.depth)} m`,
            draught: `${formatNumber(data.draught)} m`,
            lightweight: `${formatNumber(data.lightweight)} MT`
        };

        return particularsData;
    }, [data]);

    return <ParticularsGrid particulars={particulars} />;
};
